import React from "react";
import { cn } from "./cn";

function Icon({ children, className, size = 20, strokeWidth = 2, ...rest }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      width={size}
      height={size}
      className={cn("shrink-0", className)}
      aria-hidden
      {...rest}
    >
      {children}
    </svg>
  );
}

export const IconMenu = (props) => (
  <Icon {...props}>
    <path d="M3 6h18M3 12h18M3 18h18" />
  </Icon>
);

export const IconClose = (props) => (
  <Icon {...props}>
    <path d="m6 6 12 12M18 6 6 18" />
  </Icon>
);

export const IconArrowLeft = (props) => (
  <Icon {...props}>
    <path d="M19 12H5" />
    <path d="m12 19-7-7 7-7" />
  </Icon>
);

export const IconTrophy = (props) => (
  <Icon {...props}>
    <path d="M8 21h8" />
    <path d="M12 17v4" />
    <path d="M7 3h10v5a5 5 0 0 1-10 0V3Z" />
    <path d="M17 5h3v1a3 3 0 0 1-3 3" />
    <path d="M7 5H4v1a3 3 0 0 0 3 3" />
  </Icon>
);

export const IconTv = (props) => (
  <Icon {...props}>
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="m8 2 4 3 4-3" />
  </Icon>
);

export const IconSoccer = (props) => (
  <Icon {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="m9.5 9.5 2.5-1.5 2.5 1.5-.5 2.8h-3.9Z" />
    <path d="m8.5 15 1.8-1.2M15.5 15l-1.8-1.2M7 11.5l1.9.4M17 11.5l-1.9.4" />
  </Icon>
);

export const IconSettings = (props) => (
  <Icon {...props}>
    <path d="M12 15.5A3.5 3.5 0 1 0 12 8.5a3.5 3.5 0 0 0 0 7Z" />
    <path d="m19.4 15-.9 1.6 1.1 2-2 2-2-1.1-1.6.9L12 23l-2.1-1.6-1.6-.9-2 1.1-2-2 1.1-2-.9-1.6L1 12l1.6-2.1.9-1.6-1.1-2 2-2 2 1.1 1.6-.9L12 1l2.1 1.6 1.6.9 2-1.1 2 2-1.1 2 .9 1.6L23 12Z" />
  </Icon>
);

export const IconStar = (props) => (
  <Icon {...props}>
    <path d="m12 2.7 2.8 5.7 6.3.9-4.6 4.5 1.1 6.3L12 17.2 6.4 20l1.1-6.2L2.9 9.3l6.3-.9Z" />
  </Icon>
);

export const IconUserPlus = (props) => (
  <Icon {...props}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M19 8v6M16 11h6" />
  </Icon>
);

export const IconSearch = (props) => (
  <Icon {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </Icon>
);

export const IconUsers = (props) => (
  <Icon {...props}>
    <path d="M16 21v-1a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v1" />
    <circle cx="8.5" cy="7" r="4" />
    <path d="M20 8v6M17 11h6" />
  </Icon>
);

export const IconTap = (props) => (
  <Icon {...props}>
    <path d="M12 3v4" />
    <path d="M16.2 4.8 14 7" />
    <path d="M7.8 4.8 10 7" />
    <path d="M12 7v10" />
    <path d="M12 17h4a3 3 0 0 0 3-3v-2" />
    <path d="M12 17H8a3 3 0 0 1-3-3v-1" />
  </Icon>
);

export const IconCalendar = (props) => (
  <Icon {...props}>
    <rect x="3" y="4" width="18" height="17" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </Icon>
);

export const IconClock = (props) => (
  <Icon {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </Icon>
);

export const IconChart = (props) => (
  <Icon {...props}>
    <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
  </Icon>
);

export const IconEye = (props) => (
  <Icon {...props}>
    <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" />
    <circle cx="12" cy="12" r="2.5" />
  </Icon>
);

export const IconPlay = (props) => (
  <Icon {...props}>
    <polygon points="8 5 19 12 8 19 8 5" />
  </Icon>
);

export const IconPlus = (props) => (
  <Icon {...props}>
    <path d="M12 5v14M5 12h14" />
  </Icon>
);

export const IconChevronLeft = (props) => (
  <Icon {...props}>
    <path d="m15 18-6-6 6-6" />
  </Icon>
);

export const IconChevronRight = (props) => (
  <Icon {...props}>
    <path d="m9 18 6-6-6-6" />
  </Icon>
);

export const IconZoomIn = (props) => (
  <Icon {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="M11 8v6M8 11h6M20 20l-3.5-3.5" />
  </Icon>
);

export const IconZoomOut = (props) => (
  <Icon {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="M8 11h6M20 20l-3.5-3.5" />
  </Icon>
);

export const IconCenter = (props) => (
  <Icon {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
  </Icon>
);
